import { css } from '@emotion/react';
import type { Theme } from '@emotion/react';

import { breakpoint } from '@twistopayments/design-system/styles';

export const text = {
  default: (theme: Theme) => css`
    margin-top: ${theme.spacing[20]};

    ${breakpoint.down('sm')} {
      margin-top: ${theme.spacing[16]};
    }

    &:first-of-type {
      margin-top: ${theme.spacing[8]};

      ${breakpoint.down('sm')} {
        margin-top: ${theme.spacing[4]};
      }
    }
  `,

  md: (theme: Theme) => css`
    margin-top: ${theme.spacing[24]};
  `,
};
